export default __webpack_public_path__ + "static/media/Outfit-SemiBold.ea851e9b.ttf";